<template>
    <div class="venting-warp">
        <div class="msg-box">尊敬的合作伙伴，您好！感谢您对A.O.史密斯的信赖，如果您在合作过程中有任何问题，请告诉给我们，我们高度重视您的每一个反馈，感谢您的支持。</div>
        <div class="form-box">
            <van-form ref="form" @submit="onSubmit">
                <div class="form-item">
                    <div class="form-label required">问题描述</div>
                    <van-field name="msg" v-model="oForm.msg" class="form-input textarea" type="textarea"
                               placeholder="请输入留言" :rules="oRules.msg"/>
                </div>
                <div class="form-item">
                    <div class="form-label required">您的姓名</div>
                    <van-field name="name" class="form-input text" v-model="oForm.name" type="text"
                               placeholder="请输入您的姓名" :rules="oRules.name"/>
                </div>
                <div class="form-item">
                    <div class="form-label required">地址(省/市)</div>
                    <van-field name="city" class="form-input text" v-model="sCityText" readonly placeholder="请选择城市"
                               :rules="oRules.city" @click="touchShowCity">
                        <template #right-icon>
                            <div class="arrow-bottom"></div>
                        </template>
                    </van-field>
                </div>
                <div class="form-item">
                    <div class="form-label required">您的手机号</div>
                    <van-field name="phone" v-model="oForm.phone"  type="number" :rules="oRules.phone" class="form-input text" :maxlength="11" placeholder="请输入您的手机号"/>
                </div>
                <van-button v-if="!isShowShare" class="submit-btn" round block type="info" native-type="submit">提交
                </van-button>
            </van-form>
        </div>

        <share ref="myShare" v-if="isShowShare" :isFixed="true"></share>

        <div class="home_icon" @click="toHome" :style="{bottom:  '108px'}">
            <img src="~@/assets/images/processv2/tohome.png"/>
        </div>

        <van-popup v-model="isSelectCity" round position="bottom" @click-overlay="touchShowCity">
            <van-cascader
                v-model="nCity"
                title="请选择城市"
                active-color="#355D4B"
                :options="arrTree"
                @close="touchShowCity"
                @finish="onConfirmCity"
            />
            <div class="safe-area"></div>
        </van-popup>
    </div>
</template>

<script>

import {getTree , feedadd} from "@/js/designer";
import {Form} from "vant";
import share from "../components/share.vue";


export default {
    name: "Venting",
    components: {
        vanForm: Form,
        share: share
    },
    data() {
        return {
            oForm: {
                msg: '',
                name: '',
                city: '',
                phone: '',
            },
            oRules: {
                msg: [{required: true, message: ''}],
                name: [{required: true, message: ''}],
                city: [{required: true, message: ''}],
                phone: [{required: true, message: ''}],
            },
            arrTree: [],
            isSelectCity: false,
            isShowShare: false,
            nCity: 0,
            sCityText: '',
            isUpload:false,//是否处于提交
        }
    },
    created() {
        this.$store.commit("loadSkeleton", {bool: true}); // 页面loading开启
        $init(() => {
            this.$oInitData.designerInfo({
                h5_user_id: this.$storage.getStorage("user_id"),
            }).then((res) => {
                this.getTreeFun().then(() => {
                    let objData = this.$route.query;
                    if (objData.sampleroom == 2) {
                        this.isShowShare = true;
                    }
                    this.$store.commit("loadSkeleton", {bool: false});
                })
            }).catch((error) => {
                this.$store.commit("loadSkeleton", {bool: false}); // 页面loading关闭
            });

        })
    },
    methods: {
        toHome() {
            this.$router.go(-1)
        },
        getTreeFun() {
            return new Promise((resolve, reject) => {
                getTree().then((res) => {
                    let arrTree = res.data.data.result;
                    this.arrTree = [];
                    let arrProvince = arrTree[0];
                    arrProvince.forEach((it) => {
                        it["text"] = it.name;
                        it["value"] = it.id;
                        if (arrTree[it.id].length) {
                            it["children"] = arrTree[it.id];
                            it.children.forEach((sit) => {
                                sit["text"] = sit.name;
                                sit["value"] = sit.id;
                            });
                        }
                    });
                    this.arrTree = arrProvince.splice(1);
                    console.log(this.arrTree,'省市区')
                    resolve()
                });
            })
        },
        touchShowCity() {
            this.isSelectCity = !this.isSelectCity;
        },
        onConfirmCity(e) {
            let arr = e.selectedOptions;
            console.log(arr)
            this.oForm.city = [];
            this.sCityText = '';
            arr.forEach((it) => {
                this.sCityText += (this.sCityText ? ('/' + it.name) : it.name)
                this.oForm.city.push(it.value)
            })
            this.nCity = this.oForm.city[this.oForm.city.length - 1];
            this.isSelectCity = false;
        },
        /**
         * @param {string || Number} phoneNum - 手机号.
         */
        checkPhoneNum(phoneNum) {
            let checkRule = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
            if (!checkRule.test(phoneNum)) {
                return false
            } else {
                return true
            }
        },
        onSubmit() {
            if(this.isUpload)return
            this.$refs.form.validate(['msg', 'name', 'city', 'phone']).then((res) => {
                if(!this.checkPhoneNum(this.oForm.phone)){
                    this.$toast('请输入正确的手机号~')
                    return
                }
                let data = {}
                data.name=this.oForm.name
                data.phone=this.oForm.phone
                data.content=this.oForm.msg
                data.province_id=this.oForm.city[0]
                data.city_id=this.oForm.city[1]
                console.log(data)
                this.$store.commit('loadSwitch',true)
                this.isUpload=true
                feedadd(data).then(res=>{
                    this.$store.commit('loadSwitch',false)
                    this.$toast('提交成功~')
                    setTimeout(()=>{
                        this.$router.back()
                    },800)
                    console.log(res)
                })
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./index";
</style>
